
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.7 19.3L9.4 12l7.3-7.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-8 8c-.4.4-.4 1 0 1.4l8 8c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4z"}})])
          )
        }
      }
    